import { Personnel } from './personnel';
import { Analyse } from "./analyse";
import { Users } from './users';
import { Consultation } from "./consultation";
import { Prescription } from "./prescription";
import { Patients, Personne } from ".";

export class PrescriptionAnalyse {
  id: number;
  consultation: Consultation;
  analyse: Analyse;
  prescription: Prescription;
  patient: Patients;
  user: Users;
  etat: boolean;
  interne: boolean;
  commentaire: string;
  cout: number;
  coutExonere: number;
  datePrescription: any;
  dateRealisation: any;
  resultat: string;
  medecin: Personnel;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/prescription-analyse.ts